__turbopack_context__.v({
  "container": "FaqSection-module-scss-module__0pRFBG__container",
  "faq-section": "FaqSection-module-scss-module__0pRFBG__faq-section",
  "form-wrapper": "FaqSection-module-scss-module__0pRFBG__form-wrapper",
  "formSection": "FaqSection-module-scss-module__0pRFBG__formSection",
  "layout": "FaqSection-module-scss-module__0pRFBG__layout",
  "layoutRFIDisabled": "FaqSection-module-scss-module__0pRFBG__layoutRFIDisabled",
  "layoutSpecific": "FaqSection-module-scss-module__0pRFBG__layoutSpecific",
  "lead-form-section": "FaqSection-module-scss-module__0pRFBG__lead-form-section",
  "lpLayout": "FaqSection-module-scss-module__0pRFBG__lpLayout",
});
